import Text from 'components/Text';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex-direction: row;
  justify-content: space-between;
  border-width: 1px;
  border-color: ${props => props.theme.colors.base.slot1};
  border-radius: 20px;
  margin-bottom: 16px;
`;

export const Button = styled.TouchableOpacity`
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 8px;
  height: 40px;
  background-color: ${props =>
    props.active ? props.theme.colors.base.slot1 : 'transparent'};
  border-radius: 18px;
`;

export const ButtonText = styled(Text)`
  color: ${props =>
    props.active
      ? props.theme.colors.grayscale.slot1
      : props.theme.colors.base.slot1};
  font-family: ${props => props.theme.fonts.weight[500]};
`;
